export default "__VITE_ASSET__72ee5acd__"